import classNames from "classnames/bind";
import styles from './FormRegister.module.css';
import Button from "../../../../../components/Button/Button";
import { useCallback, useEffect, useState } from "react";
import InputText from "./InputText";
import { generateAutoPassword, isValidatePassword, isValidateUserName, isValidatorEmail } from "../../../../../utils";
import { Loading, SelectBox, SelectBoxItem, Toast } from "../../../../../components";
import axiosClient from "../../../../../services/axiosClient";
import ModalAddRole from "../ModalAddRole";
import { AddNewUserContext } from "../../../../../contexts";
import FormItem from "../../../../InfoUser/ChangePassword/FormItem/FormItem";
const cx = classNames.bind(styles);

function FormCreateUser({ getError, onBack }) {
    const company = sessionStorage.getItem('company_code')
    const [name, setName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [companyName, setCompanyName] = useState({ name: 'Lựa chọn', code: null });
    const [permission, setPermission] = useState({ name: '', code: null });
    const [error, setError] = useState(false);
    const [companies, setCompanies] = useState();
    const [userType, setUserType] = useState();
    const [addNewRole, setAddNewRole] = useState(false);
    const [newCodeRole, setNewCodeRole] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [autoCrePass, setAutoCrePass] = useState(true);
    const [requestChangePass, setRequestChangePass] = useState(true);
    const [sendPass, setSendPass] = useState(false);
    const [password, setPassword] = useState();
    const [submitErr, setSubmitErr] = useState(false);
    const getCompany = useCallback(async () => {
        try {
            const res = await axiosClient.get(`company/get-list-company/`);
            setCompanies(res);
            if (company !== 'DEFAULT') {
                setCompanyName({ name: res[0].NAME, code: res[0].CODE })
            }
        } catch (error) {
            Toast.open('Lấy danh sách công ty không thành công', 'danger');
        }
    }, [company])
    const getListPermissions = useCallback(async (code, newRole) => {
        try {
            if (code) {
                const res = await axiosClient.get(`userType/get-list-userType-for-add-user/?company_code=${code}`);
                if (newRole) {
                    const newCode = res?.filter(item => item?.CODE === newRole);
                    setPermission({ name: newCode[0]?.SUBJECT_NAME, code: newCode[0]?.CODE });
                }
                setUserType(res)
            }
        } catch (error) {
            Toast.open('Không thể lấy ra danh sách quyền người dùng', 'danger');
        }
    }, [])

    useEffect(() => {
        getListPermissions(companyName.code, newCodeRole)
    }, [getListPermissions, newCodeRole, companyName.code])

    useEffect(() => {
        getCompany()
    }, [getCompany])

    const handleChangeName = (data) => {
        setName(data)
    }

    const handleChangeUserName = (data) => {
        setUserName(data)
    }

    const handleChangeEmail = (data) => {
        setEmail(data)
        const index = data.indexOf('@')
        if (index >= 0) {
            setUserName(data?.slice(0, index))
        }
    }

    const onChangeCompany = (data) => {
        if (data === 'all') {
            setError(true)
        } else {
            setError(false)
            const com = companies?.filter(item => item.CODE === data);
            setCompanyName({ name: com[0]?.NAME, code: com[0]?.CODE });
            setPermission({ name: '', code: null });
        }
    }

    const onChangePermission = (data) => {
        if (!companyName.code) {
            setError(true)
        } else {
            setError(false)
            const per = userType?.filter(item => item.CODE === data);
            setPermission({ name: per[0]?.SUBJECT_NAME, code: per[0]?.CODE });
        }
    }

    const onAddRole = () => {
        setAddNewRole(!addNewRole)
    }

    const handleChangeAutoCreatePass = (e) => {
        setAutoCrePass(e.target.checked)
        if (!e.target.checked) {
            setPassword('')
        }
    }

    const handleRequestChangePass = (e) => {
        setRequestChangePass(e.target.checked)
    }

    const handleSendPassToEmail = (e) => {
        setSendPass(e.target.checked)
    }

    const handleTypeNewPassword = (e) => {
        setPassword(e)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setIsLoading(!isLoading)
        const role = isValidateUserName(userName) && isValidatorEmail(email) && permission.code && name.trim().length > 0 && isValidatePassword(password);
        const checkEmail = email.length > 0 ? isValidatorEmail(email) : true;
        const roleDonSend = isValidateUserName(userName) && checkEmail && permission.code && name.trim().length > 0 && isValidatePassword(password);
        const validate = sendPass ? role : roleDonSend;
        const first = userName.trim().length === 0 || !checkEmail || name.trim().length === 0 || !permission.code;
        if (first) {
            Toast.open('Vui lòng nhập đúng tất cả các trường', 'danger')
            setSubmitErr(true)
            setIsLoading(false)
        } else if (validate) {
            const getCode = async () => {
                try {
                    const res = await axiosClient.post(`userManagement/post-add-userManagement/`, {
                        name: name,
                        username: userName,
                        email: email.length > 0 ? email : '',
                        company_code: companyName.code,
                        usertype_code: permission.code,
                        change_password: requestChangePass ? '1' : null,
                        send_email: sendPass ? '1' : null,
                        password: password
                    })
                    if (sendPass) {
                        Toast.open('Tạo thài khoản thành công vui lòng kiểm tra email', 'success')
                    }
                    setIsLoading(false)
                    onBack()
                    return res
                } catch (error) {
                    if (error.response.data.username && error.response.data.email) {
                        getError('Tên đăng nhập Hoặc Email của bạn không hợp lệ')
                    } else if (error.response.data.username) {
                        getError(error.response.data.username[0])
                    } else if (error.response.data.email) {
                        getError(error.response.data.email[0])
                    } else if (!companyName || companyName === 'all') {
                        getError('Vui lòng chọn công ty')
                    } else (
                        getError('Email hoặc tên người dùng của bạn đã được sử dụng')
                    )
                    setIsLoading(false)
                }
            }
            getCode()
        } else {
            setIsLoading(false)
            setSubmitErr(true)
            Toast.open('Vui lòng nhập đúng tất cả các trường', 'danger')
        }
    }

    useEffect(() => {
        if (autoCrePass) {
            let newPass = generateAutoPassword();
            setPassword(newPass)
        }
    }, [autoCrePass])

    return (
        <AddNewUserContext.Provider value={{ setNewCodeRole, onAddRole }}>
            <div id="__notification"></div>
            <div className={cx('register-form')}>
                <InputText
                    title={'Tên người dùng *'}
                    row
                    register
                    value={name}
                    name={'NAME'}
                    placeholder={'Nhập'}
                    onChange={handleChangeName}
                />
                <InputText
                    title={`Email ${sendPass ? '*' : ''}`}
                    row
                    register
                    value={email}
                    name={"EMAIL"}
                    placeholder={'Nhập'}
                    onChange={handleChangeEmail}
                />
                <InputText
                    title={'Tên đăng nhập *'}
                    row
                    register
                    value={userName}
                    name={'USERNAME'}
                    placeholder={'Nhập'}
                    onChange={handleChangeUserName}
                />
                <div className={cx('options-pass')}>
                    <div className={cx('name-fill')}>Tạo mật khẩu *</div>
                    <div className={cx('list-options')}>
                        <div className={cx('item-option')}>
                            <input
                                className={cx('check-box')}
                                type="checkbox"
                                onChange={(e) => handleChangeAutoCreatePass(e)}
                                checked={autoCrePass}
                            />
                            <label className={cx('label')}>Tự động tạo mật khẩu</label>
                        </div>
                        <div className={cx('password-input')}>
                            <label className={cx('label')}>Mật khẩu *</label>
                            <FormItem
                                label={''}
                                name={'newPassword'}
                                values={password}
                                onChange={handleTypeNewPassword}
                                type={'password'}
                                warning={'Dài 6 - 20 kí tự, bao gồm cả chữ, số, viết hoa, viết thường và cả những kí tự đặc biệt!'}
                                rules={[
                                    {
                                        isRequire: true,
                                        mess: 'Mật khẩu không được để trống!'
                                    },
                                ]}
                                disable={autoCrePass}
                            />
                        </div>
                        <div className={cx('item-option')}>
                            <input
                                className={cx('check-box')}
                                type="checkbox"
                                onChange={(e) => handleRequestChangePass(e)}
                                checked={requestChangePass}
                            />
                            <label className={cx('label')}>Yêu cầu người dùng này đổi mật khẩu khi đăng nhập lần đầu</label>
                        </div>
                        <div className={cx('item-option')}>
                            <input
                                className={cx('check-box')}
                                type="checkbox"
                                onChange={(e) => handleSendPassToEmail(e)}
                                checked={sendPass}
                            />
                            <label className={cx('label')}>Gửi mật khẩu về email khi hoàn thành</label>
                        </div>
                    </div>
                </div>
                <div className={cx('select-box')}>
                    <label className={cx("title")}>Công ty trực thuộc *</label>
                    <div>
                        <button className={cx('input-textbox', 'select-box-item')} onClick={e => e.preventDefault()}>
                            <SelectBox
                                type="small"
                                style={{ paddingTop: 8 }}
                                onChange={onChangeCompany}
                                required={error}
                                values={companyName?.name}
                            >
                                {companies && companies.map((item, index) => {
                                    return (
                                        <SelectBoxItem key={index} label={item.NAME} value={item.CODE} />
                                    )
                                })}
                            </SelectBox>
                        </button>
                        {submitErr && !companyName.code && <p className={cx("span-error")}>{'Công ty trực thuộc không được để trống!'}</p>}
                    </div>
                </div>
                <div className={cx('select-box')}>
                    <label className={cx("title")}>Phân quyền người dùng *</label>
                    <div className={cx('add-role')}>
                        <button className={cx('input-textbox', 'select-box-item')} onClick={e => e.preventDefault()}>
                            <SelectBox
                                type="small"
                                style={{ paddingTop: 8 }}
                                onChange={onChangePermission}
                                required={error}
                                values={permission?.name.length > 0 ? permission?.name : 'Lựa chọn'}
                            >
                                {userType ? userType.map((item, index) => {
                                    return (
                                        <SelectBoxItem key={index} label={item.SUBJECT_NAME} value={item.CODE} />
                                    )
                                }) : <span></span>}
                            </SelectBox>
                        </button>
                        {submitErr && !permission.code && <p className={cx("span-error")}>{'Phân quyền người dùng không được để trống!'}</p>}
                        <p className={cx('desc')}>Hoặc</p>
                        <div className={cx('new-role')}>
                            <button className={cx('button-add')} onClick={onAddRole}>Tạo một quyền mới</button>
                        </div>
                    </div>
                </div>
                <button className={cx('button-change')} type={'submit'}>
                    <Button
                        title="Tiếp tục"
                        onClick={handleSubmit}
                    />
                </button>
            </div>
            {isLoading && <div className={cx('loading')}><Loading /></div>}

            {addNewRole && (
                <ModalAddRole />
            )}
        </AddNewUserContext.Provider>
    )
}
export default FormCreateUser;